import { LicenseMonthlyResellBundleFormWebComponent } from './component/LicenseMonthlyResellBundleFormWebComponent';
import { WEB_COMPONENT_LICENSE_MONTHLY_RESELL_BUNDLE_FORM } from '../../../webcomponents.constants';

export { LicenseMonthlyResellBundleFormWebComponent };

window.customElements.define(
  WEB_COMPONENT_LICENSE_MONTHLY_RESELL_BUNDLE_FORM,
  LicenseMonthlyResellBundleFormWebComponent
);
